import { combineReducers } from 'redux';

import verificationclose from './verificationclose/reducer';

export default combineReducers({
  verificationclose,
});



// WEBPACK FOOTER //
// ./src/pages/verificationclose/state/reducer.js